<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>

			<div class="videobg">
				<!-- 修改为 video.js 的播放器结构 -->
				<div style="position: relative;">
					<div data-vjs-player>
						<video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" preload="auto">
							抱歉，您的浏览器不支持视频播放
						</video>
					</div>
					
					<!-- 标记点弹框 -->
					<div class="tooltip-overlay" id="tooltip-overlay" v-show="showTooltip">
						<div class="tooltip-content">
							{{ currentTooltipText }}
						</div>
					</div>
				</div>

				<!-- 移除原有的标记点容器和提示信息，videojs-markers 会自行处理 -->
				<div class="tryVideo" v-if="showTryVideo">
					<div class="text">试看已结束</div>
					<div class="bus flex">
						<div class="btn1" @click="toDetail(1)">购买整课</div>
						<div class="btn2" @click="toDetail(2)">购买本章</div>
					</div>
				</div>
			</div>
			<div class="titlescc"><span>第{{currentIndex+1}}章</span>{{pathList[2].title}}</div>
		</div>
	</div>
</template>

<script>
	import videojs from 'video.js';
	import 'video.js/dist/video-js.css';
	import 'videojs-markers';
	import 'videojs-markers/dist/videojs.markers.css';

	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser
	} from '@/api/mine';
	import {
		getConfigList,
		getConfigDetail
	} from '@/api/common';
	import {
		getCourseDetail,
		addCollect,
		delCollect,
		getCourse,
		getCourseOrderEvaluate,
		getUserChapter,
		getCourseOrder,
		addCourseOrderEvaluate,
		putUserChapter
	} from "@/api/course";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Breadcrumb from "../../components/Breadcrumb.vue";
	import Pagination from "../../components/Pagination.vue";
	import toTop from "../../components/toTop.vue";

	export default {
		data() {
			return {
				showTooltip: false,
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '我的课程',
					path: '/allCourse'
				}, {
					title: '',
					path: ''
				}],
				loginUser: '',
				detail: '',
				courseId: '',
				currentChapter: '',
				videoUrl: 'https://gymoo-project-cdn-new.oss-cn-shenzhen.aliyuncs.com/academy/dd0b4d3c70ad38d42af63000b8edd70c.mp4',
				points: [],
				player: null, // 改为 player
				currentIndex: 0,
				showTryVideo: false,
				currentTooltipText: '', // 当前显示的提示文本
			}
		},
		components: {
			TopHeader,
			Footer,
			Breadcrumb,
			Pagination,
			toTop,
		},
		mounted() {
			this.courseId = this.$route.query.courseId
			this.chapterId = this.$route.query.chapterId
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.getCourseDetail()
		},
		beforeUnmount() {
			// 组件销毁时清理播放器实例
			if (this.player) {
				this.player.dispose();
			}
		},
		methods: {
			toDetail(type) {
				if (type == 1) {
					this.$router.push({
						path: '/courseBuy?id=' + this.detail.uuid + '&course_cate_name=' + this.detail
							.course_cate_name+'&buyAll=1'
					})
				}else{
					let arr = []
					arr.push(this.currentChapter)
					Utils.setCookie("buyChapters", JSON.stringify(arr), 1)
					this.$router.push({
						path: '/courseBuy?id=' + this.detail.uuid + '&course_cate_name=' + this.detail
							.course_cate_name+'&buyAll=0'
					})
				}
			},
			// 检查是否到达标记点时间
			checkMarkerTimepoints(currentTime) {
				if (this.points.length == 0) return
				this.points.forEach(point => {
					// 使用0.5秒的容差范围
					if (Math.abs(currentTime - point.part_time) < 0.5) {
						this.showTooltipWithText(point.desc);
					}
				});
			},
			// 显示提示信息（按照图片样式）
			showTooltipWithText(text) {
				// 如果已经有提示显示，先清除之前的定时器
				if (this.tooltipTimeout) {
					clearTimeout(this.tooltipTimeout);
				}

				// 更新提示文本并显示
				this.currentTooltipText = text;
				this.showTooltip = true;

				// 设置5秒后自动隐藏
				this.tooltipTimeout = setTimeout(() => {
					this.hideTooltip();
				}, 5000);
			},
			// 隐藏提示信息
			hideTooltip() {
				this.showTooltip = false;
				if (this.tooltipTimeout) {
					clearTimeout(this.tooltipTimeout);
					this.tooltipTimeout = null;
				}
			},
			initPlayer() {
				this.$nextTick(() => {
					// video.js 配置选项 [1,2](@ref)
					const options = {
						autoplay: false,
						controls: true,
						preload: 'auto',
						fluid: true, // 自适应容器
						width: '100%',
						height: 675,
						playbackRates: [0.5, 1, 1.25, 1.5, 2],
						sources: [{
							src: this.currentChapter.file.url,
							type: 'video/mp4'
						}]
					};

					// 初始化 video.js 播放器 [1](@ref)
					this.player = videojs(this.$refs.videoPlayer, options, () => {
						console.log('播放器准备就绪');

						// 设置标记点 [2,3](@ref)
						this.setupMarkers();

						// 监听时间更新事件
						this.player.on('timeupdate', () => {
							const currentTime = this.player.currentTime();
							const duration = this.player.duration();

							// 提交学习进度
							if (this.currentChapter.is_buy == 1) {
								this.putUserChapter(currentTime)
							}

							// 试看逻辑
							if (this.currentChapter.is_buy != 1 && this.currentChapter.is_see ==
								1 &&
								this.currentChapter.permission == 1 && currentTime >= this
								.currentChapter.seconds) {
								this.showTryVideo = true
								this.player.pause()
							}

							// 检查是否到达标记点时间
							this.checkMarkerTimepoints(currentTime);
						});

						// 监听播放结束事件
						this.player.on('ended', () => {
							console.log('视频播放结束');
						});
					});
				});
			},

			// 设置标记点 [2,3,6](@ref)
			setupMarkers() {
				if (!this.player || this.points.length === 0) return;

				// 转换 points 数据为 markers 需要的格式
				const markers = this.points.map(point => ({
					time: point.part_time,
					text: point.desc || point.name,
					class: 'custom-marker'
				}));

				// 配置 markers [6,8](@ref)
				this.player.markers({
					markerStyle: {
						width: '8px',
						height: '8px',
						'background-color': '#FFFFFF',
						'border-radius': '50%',
						bottom: '-50%',
					},
					markerTip: {
						display: true,
						text: function(marker) {
							return marker.text;
						}
					},
					// breakOverlay: {
					//     display: true,
					//     displayTime: 3,
					//     text: function(marker) {
					//       return "当前标记：" + marker.text;
					//     }
					//   },
					markers: markers,
					onMarkerClick: (marker) => {
						// 点击标记点跳转到对应时间
						this.player.currentTime(marker.time);
						this.player.play();
					},
					onMarkerReached: (marker) => {
						console.log('到达标记点:', marker.text);
					}
				});
			},

			// 提交学习进度
			async putUserChapter(currentTime) {
				const {
					status,
					data
				} = await putUserChapter({
					uuid: this.currentChapter.uuid,
					persent: currentTime / this.currentChapter.file.second * 100
				})
				this.loginUser = data.result
			},

			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},

			async getCourseDetail() {
				const {
					status,
					data
				} = await getCourseDetail({
					uuid: this.courseId,
				});
				this.detail = data.result
				this.currentChapter = this.detail.chapter.find(item => {
					return item.uuid == this.chapterId
				})
				this.currentIndex = this.detail.chapter.findIndex(item => {
					return item.uuid == this.chapterId
				})
				this.pathList[2].title = this.currentChapter.name
				this.points = this.currentChapter.points
				this.initPlayer()
			},

			goBack() {
				this.$router.go(-1)
			},
		}
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;

		.videobg {
			position: relative;

			// video.js 容器样式
			:deep(.video-js) {
				width: 100%;
				height: 675px;
				margin: 24px 0;

				// 自定义标记点样式 [6,8](@ref)
				.vjs-marker:hover {
					// transform: scale(1.2);
					cursor: pointer;
				}
			}
		}

		.titlescc {
			margin-top: 20px;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #999999;
				margin-right: 12px;
			}

			font-family: HONOR Sans CN,
			HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #333333;
		}

		// 试看样式保持不变
		.tryVideo {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.56);
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			z-index: 100;

			.text {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #FFFFFF;
			}

			.bus {
				margin-top: 28px;

				.btn1 {
					display: flex;
					align-items: center;
					justify-content: center;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					color: #10B649;
					width: 124px;
					height: 40px;
					background: #FFFFFF;
					border-radius: 12px 12px 12px 12px;
				}

				.btn2 {
					margin-left: 36px;
					width: 124px;
					height: 40px;
					background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
					border-radius: 12px 12px 12px 12px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					color: #FFFFFF;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}

	/* 提示信息样式 */
	.tooltip-overlay {
		position: absolute;
		bottom: 60px;
		left: 1%;
		// transform: translateX(-50%);
		background: rgba(0, 0, 0, 0.85);
		color: white;
		padding: 12px 16px;
		border-radius: 6px;
		z-index: 20;
		// max-width: 300px;
		max-width: 98%;
		text-align: center;
		animation: fadeInUp 0.3s ease;

		@keyframes fadeInUp {
			from {
				opacity: 0;
				transform: translateX(-50%) translateY(10px);
			}

			to {
				opacity: 1;
				transform: translateX(-50%) translateY(0);
			}
		}
	}

	.tooltip-content {
		font-size: 14px;
		line-height: 1.4;
		font-family: system-ui, -apple-system, sans-serif;
	}

	::v-deep .vjs-marker {
		// bottom: 0em;
	}

	.videobg ::v-deep .vjs-tip .vjs-tip-inner {
		font-size: 14px !important;
		/* 字体大小 */
		color: #ffffff !important;
		/* 文字颜色 */
		background-color: rgba(0, 0, 0, 0.9) !important;
		/* 背景色 */
		padding: 12px !important;
		/* 内边距 */
		border-radius: 8px !important;
		/* 圆角 */
		border: 1px solid rgba(255, 255, 255, 0.2) !important;
		/* 边框 */
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
		/* 阴影 */
		max-width: 300px !important;
		/* 最大宽度 */
		font-weight: 500 !important;
		/* 字体粗细 */
		line-height: 1.5 !important;
		/* 行高 */
		text-align: center !important;
		/* 文字对齐 */
		font-family: 'Microsoft YaHei', sans-serif !important;
		/* 字体 */
		/* 可以添加动画效果 */
		animation: tooltipFadeIn 0.2s ease-out !important;
	}
</style>